// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { injectCss } from "@insite/mobius/utilities";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import { CustomAppState } from "@tps/App/Store/Reducers";
import { HeaderSize } from "@tps/Overrides/Pages/Header";
import { xScreen } from "@tps/XDL/Utilities";
import React, { FC } from "react";
import styled, { css } from "styled-components";

interface XngStickyProps {
    css?: StyledProp<XngStickyComponentProps>;
    stickyOffset?: string;
    stopBreakpoint?: "xs" | "sm" | "md" | "lg" | "xl";
    [key: string]: any;
}

export type XngStickyComponentProps = MobiusStyledComponentProps<"div", XngStickyProps>;

const XngStickyWrapper = styled.div<XngStickyComponentProps>`
    position: sticky;
    top: ${({ stickyOffset }) => `${stickyOffset}`};
    ${({ stopBreakpoint }) => css`
        ${xScreen("lte", stopBreakpoint || "sm")} {
            position: static;
        }
    `};
    @media print {
        position: static;
    }

    ${injectCss}
`;

const XngSticky: FC<XngStickyProps> = props => {
    const { isTabletScreen, notificationBarFromState } = useAppSelector(state => ({
        isTabletScreen: (state as CustomAppState).xCommon.isTabletScreen,
        notificationBarFromState: (state as CustomAppState).xHeader.notificationBar || "90px",
    }));

    const [notificationBar, setNotificationBar] = React.useState(true);

    React.useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        const closedState = sessionStorage?.getItem('closed');
        setNotificationBar((!((closedState && closedState === 'true'))));
    }, [notificationBarFromState]);

const offset = isTabletScreen ? (notificationBar ? HeaderSize.mobile : (HeaderSize.mobile - HeaderSize.notificationBar)) : (notificationBar ? HeaderSize.default : (HeaderSize.default - HeaderSize.notificationBar) )
    
    return <XngStickyWrapper {...props} stickyOffset={`${parseFloat(offset) + 10}px`} />;
};

XngSticky.defaultProps = {
    className: "xng-sticky",
    stopBreakpoint: "sm",
};

export default XngSticky;
